export default __webpack_public_path__ + "static/media/fad-h-expand.7963f581.svg";